import * as angular from 'angular';
import template from './lineServerConfig.tpl.html';

export default angular.module('aps.controller.lineServerConfig', [])
  .directive('apsLineServerConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/lineServerConfig.directive.ts